import { message } from 'antd';
import type { RequestConfig } from '@umijs/max';
import { request } from '@@/plugin-request';
import config from '@/config/config';
import { history } from '@umijs/max';
import * as auth from './auth';

/**
 * 响应体结构
 */
export type TResponseStruct<T = any> = {
  code: number;
  msg: string;
  data: T;
  [propName: string]: any;
};

/**
 * 服务方法
 */
const service = async (url: string, opts: RequestConfig) => {
  try {
    return await request(url, {
      ...opts,
      baseURL: config.request.baseURL,
      // 统一的请求设定
      timeout: config.request.timeout || 20000,
      headers: {
        ...config.request.headers,
        access_token: auth.getToken() || '',
      },
      // 请求拦截器
      requestInterceptors: [
        (url, options) => {
          // 拦截请求配置，进行个性化处理。
          return { options, url };
        },
      ],

      // 响应拦截器
      responseInterceptors: [
        (response) => {
          // 拦截响应数据，进行个性化处理
          const { data } = response;
          if (!data) {
            message.error('请求失败！服务端无响应');
          }
          return response;
        },
      ],
    })
  } catch (e: any) {
    if (e?.response?.status === 403) {
      window.localStorage.clear()
      if (window.location.pathname !== '/Login') {
        message.error('登陆信息已过期，请重新登陆！')
        history.replace('/Login')
      }
      // return e.response.data
    }
  }
};

/**
 * get请求
 */
export const get = <T>(url: string, opts: RequestConfig = {}) => {
  return service(url, {
    ...opts,
    method: 'get',
  }) as unknown as Promise<TResponseStruct<T>>;
};

/**
 * post请求
 */
export const post = <T>(url: string, opts: RequestConfig = {}) => {
  return service(url, {
    ...opts,
    method: 'post',
  }) as unknown as Promise<TResponseStruct<T>>;
};

/**
 * put请求
 */
export const put = <T>(url: string, opts: RequestConfig = {}) => {
  return service(url, {
    ...opts,
    method: 'put',
  }) as unknown as Promise<TResponseStruct<T>>;
};

/**
 * put请求
 */
export const del = <T>(url: string, opts: RequestConfig = {}) => {
  return service(url, {
    ...opts,
    method: 'delete',
  }) as unknown as Promise<TResponseStruct<T>>;
};
